import { useState } from 'react';
import { Button, Flex, Modal, Spin, Typography } from 'antd';
import classNames from 'classnames';
import { findCountriesById } from 'shared/utils/countries';
import { useGetClientInfo } from 'client-app/api/client-user/use-get-client-info';
import { useGetCountriesForClientOffice } from 'client-app/api/countries/use-get-countries-for-client-office';
import { CompanyIcon } from 'client-app/shared/icons';
import styles from './client-modal-info.module.scss';
import { formatAddress } from './utils';

export const ClientInfoModal = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { data: countries, isLoading: isCountriesLoading } = useGetCountriesForClientOffice();
  const { data: clientInfo, isFetching: isClientInfoLoading } = useGetClientInfo(isModalVisible);
  const isLoading = isCountriesLoading || isClientInfoLoading;

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const postCountry = findCountriesById(clientInfo?.postCountryId, countries);
  const legalCountry = findCountriesById(clientInfo?.legalCountryId, countries);
  const legalAddress = formatAddress(
    clientInfo?.legalPostCode,
    legalCountry?.name,
    clientInfo?.legalCity,
    clientInfo?.legalAddress,
  );
  const postAddress = formatAddress(
    clientInfo?.postPostCode,
    postCountry?.name,
    clientInfo?.postCity,
    clientInfo?.postAddress,
  );
  const nameClassname = classNames(styles.heading, styles.black);

  return (
    <>
      <Button icon={<CompanyIcon />} type='text' onClick={showModal} />
      <Modal title='About your company:' open={isModalVisible} footer={null} onCancel={handleClose}>
        {isLoading && (
          <Flex justify='center' align='center' className={styles.spinWrapper} vertical>
            <Spin size='large' />
          </Flex>
        )}
        {clientInfo && (
          <div>
            <h5 className={nameClassname}>{clientInfo.name}</h5>
            {clientInfo.vatNumber && <Typography.Text>VAT: {clientInfo.vatNumber}</Typography.Text>}
            <br />
            {legalAddress && (
              <>
                <h5 className={styles.heading}>Legal Address:</h5>
                <Typography.Text>{legalAddress}</Typography.Text>
                <br />
              </>
            )}
            {postAddress && (
              <>
                <h5 className={styles.heading}>Postal Address:</h5>
                <Typography.Text>{postAddress}</Typography.Text>
                <br />
              </>
            )}
            {clientInfo.emailForDocuments && (
              <>
                <h5 className={styles.heading}>Email for documents:</h5>
                <Typography.Text>{clientInfo.emailForDocuments}</Typography.Text>
              </>
            )}
          </div>
        )}
      </Modal>
    </>
  );
};
